import { memo, useCallback, useContext } from 'react'

import { TtsItemContext } from '../../contextApi'
import * as Styled from './styled'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import RemoveIcon from 'assets/svgr-icons/Remove.svg'
import { TextWithIconTooltip } from 'common-components'
import { useSelector } from 'react-redux'
import { ttsThunks } from 'store/features/tts/thunks'
import { ttsSelectors } from 'store/features/tts/selectors'
import {
  useGetTtsItemLoadingState,
  useGetTtsTimelineId
} from 'containers/SubSidebar/TtsContent/hooks'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { dispatch } from 'store'

const TtsDeleteButton: React.FC = () => {
  const { id } = useContext(TtsItemContext)
  const isSingleDraftTtsItemOnly = useSelector(
    ttsSelectors.isSingleDraftTtsItemOnly
  )
  const isLoading = useGetTtsItemLoadingState(id)
  const ttsTimelineId = useGetTtsTimelineId(id)
  const isDisabled = isLoading || isSingleDraftTtsItemOnly
  const handleDelete = useCallback(() => {
    if (isDisabled) {
      return
    }
    if (ttsTimelineId) {
      dispatch(projectDataThunks.removeAudiosFromProject([ttsTimelineId]))
    }
    dispatch(ttsThunks.deleteDraftTtsItem({ id }))
  }, [ttsTimelineId, isDisabled, id])

  return (
    <Styled.TtsDeleteButtonWrapper $isDisabled={isDisabled}>
      <TextWithIconTooltip
        iconProps={{
          icon: <RemoveIcon />,
          size: 'small',
          color: 'secondarySemiDark'
        }}
        tooltipText={translate(T.TTS_DELETE_TOOLTIP)}
        tooltipPosition="top"
        onClick={handleDelete}
      />
    </Styled.TtsDeleteButtonWrapper>
  )
}

export default memo(TtsDeleteButton)
